import React from "react";
import { Swiper, SwiperSlide } from "swiper/react"
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import ico1 from "../Emergency Roadside Assistance Icons/Tyer_change.png";
import ico2 from "../Emergency Roadside Assistance Icons/Flat Tire.png";
import ico3 from "../Emergency Roadside Assistance Icons/Accident.png";
import ico4 from "../Emergency Roadside Assistance Icons/Battery Jumpstart.png";
import ico5 from "../Emergency Roadside Assistance Icons/Break Down.png";
import ico6 from "../Emergency Roadside Assistance Icons/Chani Issue.png";
import ico7 from "../Emergency Roadside Assistance Icons/Electrical Issue.png";
import ico8 from "../Emergency Roadside Assistance Icons/Gas.png";
import ico9 from "../Emergency Roadside Assistance Icons/Others.png";
import ico10 from "../Emergency Roadside Assistance Icons/clutch cable Issue.png";
import ico11 from "../Emergency Roadside Assistance Icons/starting trouble.png";









const Content6 = () => {
  const features = [
    {
      title: "Tyre Change",
      image: ico1,
      description: "We offer quick and efficient tyre replacement services to get you back on the road in no time.",
    },
    {
      title: "Flat Tire",
      image: ico2,
      description: "If you have a punctured or deflated tire, our experts will repair or replace it on the spot.",
    },
    {
      title: "Starting Trouble",
      image: ico11,
      description:
        "Starting Trouble? Our team will diagnose and fix the problem, whether it's a minor adjustment or something more complex.",
    },
    {
      title: "Battery Jumpstart",
      image: ico4,
      description:
        "We provide jumpstart services for motorcycles with dead or weak batteries, ensuring you can continue your journey",
    },
    {
      title: "Break Down",
      image: ico5,
      description:
        "If your motorcycle breaks down, we offer immediate assistance to either repair it on-site or tow it to a service station.",
    },
    {
      title: "Chain Issue",
      image: ico6,
      description:
        "Whether your chain is loose, broken, or requires lubrication, we handle all chain-related problems swiftly and effectively.",
    },
    {
      title: "Clutch Cable Issue",
      image: ico10,
      description: "We replace and adjust cables to get your bike moving again.",
    },
    {
      title: "Electrical Issue",
      image: ico7,
      description:
        "From faulty wiring to blown fuses, our technicians can diagnose and fix various electrical problems.",
    },
    {
      title: "Accident",
      image: ico3,
      description:
        "In case of an accident, we provide necessary roadside assistance, including towing and initial damage assessment.",
    },
    {
      title: "Gas",
      image: ico8,
      description: "If you run out of fuel, we deliver it directly to your location so you can continue your ride.",
    },
    {
      title: "Others",
      image: ico9,
      description:
        "MotoDoctor has you covered with a wide range of roadside services to ensure your safety and peace of mind",
    },
  ];

  const renderFeatures = (feature, index) => {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: 15, // 🔽 reduced gap
          paddingTop: 30, // 🔽 reduced
          position: "relative",
          textAlign: "center",
        }}
      >
        <img src={feature.image} alt={feature.title} width={60} height={60} />

        <div style={{ fontSize: 22, fontWeight: 800 }}>{feature.title}</div>

        <div style={{ padding: "0 25px 55px" }}>{feature.description}</div>

        {/* NUMBER BADGE */}
        <div
          style={{
            width: 60, // 🔽 slightly smaller
            height: 60,
            backgroundImage: "linear-gradient(180deg, #FF8264 30%, #FF5127 70%)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "50%",
            color: "#fff",
            fontWeight: 700,
            fontSize: 18,
            position: "absolute",
            bottom: "-30px",
          }}
        >
          {index} {/* ✅ FIXED: 1 2 3 */}
        </div>
      </div>
    );
  };

  return (
    <div style={{ backgroundColor: "#fff", padding: "50px 0" }}>
      {/* HEADING */}
      <div style={{ textAlign: "center", marginBottom: 40 }}>
        <div className="content6Head" style={{ marginTop: "25px", fontWeight: 700 }}>
          Emergency Roadside Assistance
        </div>
        <hr style={{ width: "60px", border: "1.5px solid #FF8264", margin: "10px auto" }} />
      </div>

      {/* SWIPER */}
      <div style={{ width: "90vw", margin: "0 auto" }}>
        <Swiper
          modules={[Navigation, Autoplay]}
          loop
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          navigation
          grabCursor
          spaceBetween={6} // 🔽 reduced gap
          breakpoints={{
            300: {
              slidesPerView: 1,
              centeredSlides: true,
            },
            768: {
              slidesPerView: 2,
            },
            992: {
              slidesPerView: 4, // ✅ SHOW 4 SLIDES
            },
          }}
          style={{
            padding: "10px 0", // 🔽 reduced side padding
            "--swiper-navigation-color": "#000",
            "--swiper-navigation-size": "18px",
          }}
        >
          {features.map((feature, index) => (
            <SwiperSlide
              key={index}
              style={{
                display: "flex",
                justifyContent: "center",
                paddingBottom: 50, // 🔽 reduced
              }}
            >
              <div
                style={{
                  width: 300,
                  height: 250,
                  backgroundColor: "#FAFAFA",
                  borderRadius: 10,
                  border: "0.5px solid #FFE5DE",
                }}
              >
                {renderFeatures(feature, index + 1)}
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default Content6;
